import { render, staticRenderFns } from "./WorkIconCollapse.vue?vue&type=template&id=b9bd762c"
import script from "./WorkIconCollapse.vue?vue&type=script&lang=js"
export * from "./WorkIconCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports